
import React, { Component } from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';
import { DriverForm } from './Form';


export default class DriverAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новый водитель';
  }

  onDetail = () => {
    this.props.history.push(`/driver`);
  };

  render() {
    return (
      <FormProvider
        url={'fleet/driver'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Водитель добавлен'}
        item={{
          department: this.context.data.department_active,
          is_fired: false
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание водителя'}
                backUrl={'/driver'}
              />

              <Layout.ContentSimple>
                <DriverForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать водителя
                  </YellowButton>
                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
